import React, { FC, memo, useMemo } from "react";
import { Amplify } from "aws-amplify";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import AppRoute from "../AppRoute/AppRoute";
import { awsConfig } from "@environment";
import { I18nextProvider } from "react-i18next";
import i18n from "../../../../i18n/i18n";
import { useSelector } from "react-redux";
import { getTheme } from "@modules/core/store";
import { getThemeByName } from "@ui";
import DialogProvider from "@modules/shared/DialogProvider";
import { DownloadSnackBarProvider } from "@modules/shared/DownloadSnackBarProvider";

Amplify.configure(awsConfig);

const CoreProvider: FC = (props) => {
  const selectedTheme = useSelector(getTheme);

  const theme = useMemo(() => getThemeByName(selectedTheme), [selectedTheme]);

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <I18nextProvider i18n={i18n} />
        <DialogProvider />
        <AppRoute />
        <DownloadSnackBarProvider />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default memo(CoreProvider);
